import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth is cookie-based (httpOnly access_token cookie set by /auth/login).
// `withCredentials` sends that cookie automatically on every request — no tokens live in localStorage anymore.
const api = axios.create({ baseURL: API, withCredentials: true });

/** Signed download URL. Cookie flows through <img>/<a> naturally, so no query token needed. */
export const fileUrl = (path) => `${API}/files/${path}`;

export default api;
